import styled from 'styled-components'

export default styled.div`
  align-self: center;
  font-size: 0.85rem;
  margin-right: 5px;
  width: 40%;
`



// WEBPACK FOOTER //
// ./src/components/DashboardWidgets/UsersActivity/Row/Half.js